import { render, staticRenderFns } from "./app-bar-navigation.vue?vue&type=template&id=2a0787b2&"
import script from "./app-bar-navigation.vue?vue&type=script&lang=js&"
export * from "./app-bar-navigation.vue?vue&type=script&lang=js&"
import style0 from "./app-bar-navigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports